import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  { path: '/', name: 'IndexPage', component: () => import('@/views/IndexPage.vue') },
  { path: '/about', name: 'AboutPage', component: () => import('@/views/AboutPage.vue') },
  { path: '/battery', name: 'BatteryPage', component: () => import('@/views/BatteryPage.vue') },
  { path: '/headset', name: 'HeadsetPage', component: () => import('@/views/HeadsetPage.vue') },
  { path: '/handset', name: 'HandsetPage', component: () => import('@/views/HandsetPage.vue') },
  { path: '/poweramp', name: 'PowerampPage', component: () => import('@/views/PowerampPage.vue') },
  { path: '/antenna', name: 'AntennaPage', component: () => import('@/views/AntennaPage.vue') },
  { path: '/test', name: 'TestPage', component: () => import('@/views/TestSection.vue') },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;